// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1j9JK","title":"InfoRow_title__29UcV"};